(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[296],{

/***/ 80296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content044": function() { return /* binding */ Content044; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32667);
/* harmony import */ var _Content044_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30392);
/* harmony import */ var _Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content044 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var caption = (ref1 = payload === null || payload === void 0 ? void 0 : payload.caption) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var list = (ref2 = payload === null || payload === void 0 ? void 0 : payload.list) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var ref4 = (ref3 = payload === null || payload === void 0 ? void 0 : payload.attachment) !== null && ref3 !== void 0 ? ref3 : {}, attachmentButtonText = ref4.attachmentButtonText, file = ref4.file;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .RenderIf */ .$b, {
                        viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_2__/* .VIEW_MODES.MOBILE */ .nY.MOBILE,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading3 */ .aC, {
                            className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            color: "light",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .RenderIf */ .$b, {
                                viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_2__/* .VIEW_MODES.DESKTOP */ .nY.DESKTOP,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading3 */ .aC, {
                                    className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                    color: "light",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().quote),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                        name: "blockquote",
                                        className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading5 */ .by, {
                                        className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().text),
                                        color: "light",
                                        children: caption
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .DownloadFile */ .xn, {
                                file: file,
                                label: attachmentButtonText,
                                color: "light"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content044_module_scss__WEBPACK_IMPORTED_MODULE_3___default().right),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .OrderedList */ .GS, {
                            items: list,
                            appearance: "bigger"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content044);


/***/ }),

/***/ 30392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content044_wrapper__gHNso","block":"Content044_block__Hwefw","right":"Content044_right__MQXHE","left":"Content044_left__e_NkH","title":"Content044_title__GmlDx","quote":"Content044_quote__SHASe"};

/***/ })

}]);